import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  get pageNavNext() {
    return this.element.querySelector('#page-nav .next a');
  }

  completed() {
    this.enableNextNavigation();
  }

  enableNextNavigation() {
    this.pageNavNext.removeAttribute('disabled');
  }
}
